export default __webpack_public_path__ + "static/media/lysningen-property-06.5e7bec4b.jpg";